<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false">
  <ng-template pTemplate="header">
    <div class="w-full p-2 sm:p-4 bg-lightest rounded-md">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ title }}
      </h1>
    </div>
  </ng-template>
  <div class="justify-start text-start font-medium font-app-regular p-2">
    <p class="text-center">{{ message }}</p>
  </div>
  <div class="flex justify-around items-center pt-12 space-x-4">
    <button
      *ngIf="cancelButton"
      pButton
      label="{{ 'common.cancel' | translate }}"
      (click)="closeDialog(false)"
      class="bg-white border-primary border-solid border-[1px] w-full sm:w-1/3 md:w-1/4 p-1 text-primary"></button>
    <button
      pButton
      [label]="okLabel"
      (click)="closeDialog(true)"
      class="bg-primary text-white w-full sm:w-1/3 md:w-1/4 p-1"></button>
  </div>
</p-dialog>

